import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { nationalities, gender, userRole, activeStatus } = commonConfigValues

const {
  helpers: {
    calculateAge,
    // isPhone,
    isEmail,
    // isFax,
    keepInLength
    // validateLength,
    // calculatePeriod
  }
} = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'ui',
      'firstName',
      'lastName',
      'fullName',
      'gender',
      'dob',
      'age',
      'nationality',

      'email',
      'role',
      'isActive'

      // 'accountSecurity.email',
      // 'accountSecurity.role',
      // 'accountSecurity.password',
      // 'accountSecurity.isActive',

      // 'contact.email',
      // 'contact.phone',
      // 'contact.address'
    ]
  }
]

export const defaultSorting = [{ columnName: 'email', direction: 'asc' }]

export const valueTable = {}

export const columns = [
  {
    name: 'id',
    title: 'ID',
    formField: true
  },
  {
    name: 'ui',
    title: 'Staff Member Personel No. (UI)',
    minSpace: 'Personel No. (UI) ',
    formField: true
  },
  {
    name: 'firstName',
    title: 'First Name',
    // hidden: true,
    minSpace: 'First Name ',
    formField: true
  },
  {
    name: 'lastName',
    title: 'Surname',
    // hidden: true,
    minSpace: 'Surname ',
    formField: true
  },
  {
    name: 'fullName',
    title: 'Staff Member Name',
    formField: true,
    getCellValue: row => `${row['firstName'] || ''} ${row['lastName'] || ''}`,
    maxChars: 100,
    minSpace: 'Staff Member '
  },
  {
    name: 'gender',
    title: 'Gender',
    // width: 80,
    formField: true,
    type: 'select',
    options: 'gender',
    filterField: true,
    minSpace: 'Gender '
  },
  {
    name: 'dob',
    title: 'Date of Birth',
    // width: 130,
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Date of Birth '
  },
  {
    name: 'age',
    title: 'Age',
    formField: true,
    getCellValue: row => calculateAge(row[`dob`]),
    minSpace: 'Age ',
    filterField: true,
    filterTitle: 'Age'
  },
  {
    name: 'nationality',
    title: 'Nationality',
    formField: true,
    type: 'select',
    options: 'nationalities',
    getCellValue: row =>
      _.get(
        nationalities,
        `[${_.findIndex(nationalities, ['id', row[`nationality`]])}].label`,
        row[`nationality`]
      ),
    filterField: true,
    minSpace: 'Nationality '
  },
  {
    name: 'email',
    title: 'Email',
    formField: true,
    filterField: true,
    maxChars: 50
  },
  {
    name: 'role',
    title: 'Role',
    formField: true,
    filterField: true
  },
  {
    name: 'isActive',
    title: 'Status',
    type: 'select',
    options: 'activeStatus',
    getCellValue: row =>
      _.get(
        activeStatus,
        `[${_.findIndex(activeStatus, ['value', row[`isActive`]])}].label`,
        row[`isActive`]
      ),
    formField: true,
    filterField: true
  }

  // {
  //   name: 'phone',
  //   title: 'Phone',
  //   formField: true,
  //   hidden:true,
  //   maxChars: 50
  // },
  // {
  //   name: 'address',
  //   title: 'Address',
  //   formField: true,
  //   hidden: true,
  //   maxChars: 300,
  //   minSpace: 'Contact '
  // }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'acc',
      activeName: 'user',
      historyName: 'userHistory',
      label: 'Personnel Details',
      icon: 'visibility',
      fields: [
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'ui',
            label: 'Staff Member Personel No. (UI)',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 10)
              return val
            }
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'firstName',
            label: 'First Name',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            onChange: (e, v) =>
              change(
                formName,
                'fullName',
                `${formValues.firstName || ''} ${formValues.lastName || ''}`
              ),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'lastName',
            label: 'Surname',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            onChange: (e, v) =>
              change(
                formName,
                'fullName',
                `${formValues.firstName || ''} ${formValues.lastName || ''}`
              ),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'fullName',
            label: 'Name',
            required: false,
            disabled: true
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'nationality',
            label: 'Nationality',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: nationalities.filter(f => f.id > 0).map(o => {
              return { value: o.label, label: o.label }
            })
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'dob',
            label: 'Date of Birth',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(formName, 'age', calculateAge(v))
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'age',
            label: 'Age',
            // normalize: v=> ddy(v),
            disabled: true
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'gender',
            label: 'Gender',
            required: showAsterix,
            options: gender.filter(f => f.id > 0).map(o => {
              return { value: o.label, label: o.label }
            }),
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.spacer,
          style: { height: 40 }
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'email',
            label: 'Email',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50).toLowerCase()
              return val
            },
            validate: v =>
              v
                ? isEmail(v) ? undefined : 'Enter valid email address'
                : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'role',
            label: 'Role',
            required: showAsterix,
            options: userRole.map(o => {
              return { value: o.value, label: o.label }
            }),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'isActive',
            label: 'Active',
            required: showAsterix,
            options: activeStatus.filter(f => f.label !== 'All').map(o => {
              return { value: o.value, label: o.label }
            }),
            validate: v => (v >= 0 ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.password,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'password',
          required: false,
          hint: add ? 'Enter password' : 'Enter if you want change password',
          label: 'Password',
          hidden: !add && disabled,
          validate: v =>
            !add ? undefined : v ? undefined : 'Field is required'
        },
        {
          type: fields.password,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'passwordConfirmed',
          label: 'Confirm password',
          required: showAsterix ? false : disabled || formValues.password,
          hint: (disabled || formValues.password) && 'Reenter password',
          hidden: !add && disabled,
          validate: (v, formValues) => {
            if (formValues.password && formValues.password !== v) {
              return 'Provided passwords are different'
            }
          }
        }
      ]
    },
    {
      id: 3,
      name: 'ypd',
      activeName: 'user',
      historyName: 'userHistory',
      label: 'Personnel Details',
      icon: 'person',
      hidden: true,
      // disabled: true,
      fields: [
        // [
        //   {
        //     type: fields.text,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'ui',
        //     label: 'Staff Member Personel No. (UI)',
        //     required: showAsterix,
        //     normalize: v => {
        //       const val = keepInLength(v, 10)
        //       return val
        //     }
        //   },
        //   {
        //     type: fields.text,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'firstName',
        //     label: 'First Name',
        //     required: showAsterix,
        //     normalize: v => {
        //       const val = keepInLength(v, 50)
        //       return val
        //     },
        //     onChange: (e, v) =>
        //       change(
        //         formName,
        //         'fullName',
        //         `${formValues.firstName || ''} ${formValues.lastName || ''}`
        //       ),
        //     validate: v => (v ? undefined : 'Field is required')
        //   },
        //   {
        //     type: fields.text,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'lastName',
        //     label: 'Surname',
        //     required: showAsterix,
        //     normalize: v => {
        //       const val = keepInLength(v, 50)
        //       return val
        //     },
        //     onChange: (e, v) =>
        //       change(
        //         formName,
        //         'fullName',
        //         `${formValues.firstName || ''} ${formValues.lastName || ''}`
        //       ),
        //     validate: v => (v ? undefined : 'Field is required')
        //   },
        //   {
        //     type: fields.text,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'fullName',
        //     label: 'Name',
        //     required: false,
        //     disabled: true
        //   }
        // ],
        // [
        //   {
        //     type: fields.select,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'nationality',
        //     label: 'Nationality',
        //     required: showAsterix,
        //     validate: v => (v ? undefined : 'Field is required'),
        //     options: nationalities.filter(f => f.id > 0).map(o => {
        //       return { value: o.label, label: o.label }
        //     })
        //   },
        //   {
        //     type: fields.datepicker,
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'dob',
        //     label: 'Date of Birth',
        //     required: showAsterix,
        //     openToYearSelection: openToYearSelection,
        //     hideCalendarDate: hideCalendarDate,
        //     textFieldStyle: { width: '100%', ...styles.fieldText },
        //     onChange: (e, v) => {
        //       change(formName, 'age', calculateAge(v))
        //     },
        //     validate: v => (v ? undefined : 'Field is required')
        //   },
        //   {
        //     type: fields.text,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'age',
        //     label: 'Age',
        //     // normalize: v=> ddy(v),
        //     disabled: true
        //   },
        //   {
        //     type: fields.select,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'gender',
        //     label: 'Gender',
        //     required: showAsterix,
        //     options: gender.filter(f => f.id > 0).map(o => {
        //       return { value: o.label, label: o.label }
        //     }),
        //     validate: v => (v ? undefined : 'Field is required')
        //   }
        // ],
        // {
        //   type: fields.text,
        //   style: { ...styles.fieldText },
        //   floatingLabelStyle: { ...styles.floatingLabel },
        //   name: 'email',
        //   label: 'Email',
        //   required: showAsterix,
        //   normalize: v => {
        //     const val = keepInLength(v, 50).toLowerCase()
        //     return val
        //   },
        //   validate: v =>
        //     v
        //       ? isEmail(v) ? undefined : 'Enter valid email address'
        //       : 'Field is required'
        // },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'phone',
          label: 'Contact Phone No,(s)',
          required: showAsterix,
          normalize: v => {
            const val = keepInLength(v, 50)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },

        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'address',
          label: 'Contact Address',
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        }
      ]
    }
    // {
    //   id: 2,
    //   name: 'con',
    //   activeName: 'contact',
    //   historyName: 'contactHistory',
    //   label: 'Contact Details',
    //   icon: 'supervisor_account',
    //   fields: [
    //     {
    //       type: fields.text,
    //       style: { ...styles.fieldText },
    //       floatingLabelStyle: { ...styles.floatingLabel },
    //       name: 'contact.email',
    //       label: 'Contact Email',
    //       required: showAsterix,
    //       normalize: v => {
    //         const val = keepInLength(v, 50)
    //         return val
    //       },
    //       validate: v => (v ? undefined : 'Field is required')
    //     },
    //     {
    //       type: fields.text,
    //       style: { ...styles.fieldText },
    //       floatingLabelStyle: { ...styles.floatingLabel },
    //       name: 'contact.phone',
    //       label: 'Contact Phone No,(s)',
    //       required: showAsterix,
    //       normalize: v => {
    //         const val = keepInLength(v, 50)
    //         return val
    //       },
    //       validate: v => (v ? undefined : 'Field is required')
    //     },

    //     {
    //       type: fields.text,
    //       style: { ...styles.fieldText },
    //       floatingLabelStyle: { ...styles.floatingLabel },
    //       name: 'contact.address',
    //       label: 'Contact Address',
    //          rows: 1,
   //           maxRows: 10,
    //       required: showAsterix,
    //       normalize: v => {
    //         const val = keepInLength(v, 300)
    //         return val
    //       },
    //       validate: v => (v ? undefined : 'Field is required')
    //     }
    //   ]
    // },
  ]

  return forms
}

export const activeSection = ['user'] //['user']

export const errors = [1]

export const defaultNew = {
  isActive: 1
}

// "personnel": [
//   {
//     "id": 1,
//     personnel:{
//       "ui": "1313",
//       "firstName": "AA",
//       "lastName": "BB",
//       "gender": "Male",
//       "dob": "2001-01-01T23:28:56.782Z",
//       "nationality": "Afghanistan"
//     },
//     "personnelHistory": {

//     },
//     contact:{
//       "historyId": 1,
//       "email": "sss@ss.com",
//       "phone": "1213131414",
//       "address": "12133"
//     },
//     "contactHistory": {

//     }
//   }
// ]



// WEBPACK FOOTER //
// ./src/personnel/configs/personnel.js